export default interface ICompany {
    id: number;
    name: string;
    code: string;
    description: string;
    address: string;
    microsoftTenantId: string;
    outsideScheduleTolerance: number; // arrived early or left late
    insideScheduleTolerance: number; // arrived late or left early
}

export interface IEditCompanyRequest {
    id: number;
    name: string;
    outsideScheduleTolerance: number;
    insideScheduleTolerance: number;
}

export const defaultCompany: ICompany = {
    id: 0,
    name: "",
    code: "",
    description: "",
    address: "",
    microsoftTenantId: "",
    outsideScheduleTolerance: 0,
    insideScheduleTolerance: 0,
};
